import React from 'react';
import { View, Text, StyleSheet, Font } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  infoTop: {
    marginTop: 5,
    fontSize: 7,
    fontFamily: 'Roboto',

    position: 'absolute',
    top: 10,
    left: 20,
    right: 25,
  },
  header: {
    position: 'absolute',
    left: 20,
    right: 25,
  },
  title: {
    fontSize: 12,
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontWeight: 'bold',
  },
  info: {
    fontSize: 8,
    textAlign: 'center',
    fontFamily: 'Roboto'
  },
});

const font = require('./fonts/Roboto-Regular.ttf')
const fontBold = require('./fonts/Roboto-Bold.ttf')
const fontItalic = require('./fonts/Roboto-Italic.ttf')
const fontBoldItalic = require('./fonts/Roboto-BoldItalic.ttf')

Font.register({
  family: 'Roboto', fonts: [
    { src: font },
    { src: fontBold, fontWeight: 'bold' },
    { src: fontItalic, fontStyle: 'italic' },
    { src: fontBoldItalic, fontWeight: 'bold', fontStyle: 'italic' }
  ]
});

Font.registerEmojiSource({
  format: 'png',
  url: 'https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/72x72/',
});

const calculateTopOffset = (text, setHeaderHeight) => {
  const baseOffset = 20;
  let additionalOffset = 0;

  if (text) {
    additionalOffset = Math.ceil(text.length / 100) * 4;
  }

  const value = baseOffset + additionalOffset

  if (setHeaderHeight) {
    setHeaderHeight(value)
  }

  return value;
};

const Header = (props) => {
  const headerTop = calculateTopOffset(props.infoTop, props.setHeaderHeight);

  return (
    <>
      {
        props.infoTop ?
          <View style={[styles.infoTop]} fixed={(props.fixed == null || props.fixed)}>
            <View>
              <Text>
                {props.infoTop}
              </Text>
            </View>
          </View>
          : null
      }

      <View style={[styles.header, { top: headerTop }]} fixed={(props.fixed == null || props.fixed)}>
        <View style={{ flexDirection: "row", width: "100%" }}>

          <View style={{ marginLeft: 5, width: "100%", textAlign: "center" }} >
            <Text style={styles.title}>{props.title}</Text>
            {(props.info != null ? <Text style={styles.info}>{props.info}</Text> : null)}
          </View>

        </View>
      </View>
    </>
  )

};

export { Header };
